<div class="db-website-prompt" [ngClass]="{'with-fade-animation': showFadeInAnimation}">
  <div>
    <h1 class="db-website-prompt__title" [innerHTML]="isRegenerate || !!this.website?.id ? ('text_whatYouWantToBuild' | dbText) + '?' : ('text_whatYouWantToBuild' | dbText) + ', ' + (user?.firstName || '') + '?'"></h1>

    <div class="db-website-prompt__composer-box"
         [ngClass]="{'touched': prompt.trim().length > 0 || textareaFocused}"
         (click)="onToolbarClick($event)">
        <div class="db-website-prompt__textarea-container">
          <!-- Image Upload Component Integration -->
          <db-vc-image-upload
            (closeFigma)="onCloseFigma()"
            [descInput]="descInput"
            [showFigmaLink]="showFigmaLink()"
            [builderType]="builderType"
            (fileInputTrigger)="fileInput = $event">
          </db-vc-image-upload>

          <!-- Main textarea -->
          <textarea
            #descInput
            class="db-website-prompt__textarea  db-ai-vibe "
            [(ngModel)]="prompt"
            [ngClass]="{'animated': !isProcessing}"
            (focus)="textareaFocused = true"
            (blur)="textareaFocused = false"
            (keydown)="onTextareaKeydown($event)"
            placeholder=""
            ></textarea>

        </div>

        <!-- Toolbar -->
        <!-- Voice recording component (headless) -->
        <db-voice-recording
          (transcriptUpdate)="onTranscriptUpdate($event)">
        </db-voice-recording>

        <div class="db-website-prompt__toolbar" [ngClass]="{'isRecording': !!voiceRecording?.isRecording}" (click)="onToolbarClick($event)">
          <!-- Left Section: Tools/Action buttons (only when NOT recording) -->
          <div class="db-website-prompt__toolbar-left" *ngIf="!voiceRecording?.isRecording">
            @if ((userSubscription?.availableBuilder === 'wvc' && (builderType === 'wvc' || !website))) {
                <button
                  class="db-website-prompt__btn-circle"
                  [dsTooltip]="closeTooltip() ? null : (builderType === 'section_based' ? addTooltipDisabled : addTooltip)"
                  [dsTooltipColor]="builderType === 'section_based' ? 'black' : 'white'"
                  [hostClass]="'cover-all'"
                  dsTooltipPosition="top"
                  dsTooltipAlign="left"
                  dsTooltipMode="hoverStatic"
                  (mouseenter)="closeTooltip.set(false)"
                  (onTooltipClick)="closeTooltip.set(true)"
                  [ngClass]="{'disabled': !!disableControls || isProcessing, 'none-clickable': builderType === 'section_based', 'processing': isProcessing}"
                  [disabled]="isProcessing || disableControls"
                  [dsTooltipSize]="builderType === 'section_based' ? 'xs' : 'large'">
                  <i class="db-icon db-icon-ds-add-slim"></i>
                </button>
            }
            @if (!website && userSubscription?.multipleBuilder) {
                <button
                  class="db-website-prompt__btn-pill"
                  [dsTooltip]="modelTooltip"
                  dsTooltipColor="white"
                  [hostClass]="'cover-all'"
                  dsTooltipPosition="top"
                  dsTooltipAlign="left"
                  dsTooltipSize="large"
                  dsTooltipMode="hoverStatic"
                  [dsTooltipHoveredElement]="'.actions-dropdown'"
                  [ngClass]="{'hovered': !!toggled, 'processing': isProcessing}"
                  [disabled]="isProcessing || disableControls">
                  <div class="db-website-prompt__ai-creation">
                    <i class="db-icon db-icon-{{builderType === 'wvc' ? 'ds-ai' : 'ds-sidebar-builder'}}"></i>
                    <span>{{builderType === 'wvc' ? 'AI Vibe Builder' : 'AI Classic Builder'}}</span>
                    <i class="db-icon db-icon-ds-single-arrow-small"  [ngClass]="{'toggled': toggled}"></i>
                  </div>
                </button>
            }
          </div>

          <!-- Center Section: Recording display (only when IS recording) -->
          <div class="db-website-prompt__toolbar-center" *ngIf="voiceRecording?.isRecording">
            <!-- Recording Duration with red dot indicator -->
            <div class="db-website-prompt__recording-duration">
              <span class="db-website-prompt__recording-dot"></span>
              <span class="db-website-prompt__recording-timer">{{voiceRecording.formattedDuration}}</span>
            </div>

            <!-- Audio Bars -->
            <div class="db-website-prompt__waveform">
              <div class="db-website-prompt__waveform-bars">
                <div
                  *ngFor="let bar of voiceRecording.disabledBars"
                  class="db-website-prompt__waveform-bar db-website-prompt__waveform-bar--disabled"
                  [style.height.%]="bar"></div>
                <div
                  *ngFor="let bar of voiceRecording.audioBars"
                  class="db-website-prompt__waveform-bar db-website-prompt__waveform-bar--active"
                  [style.height.%]="bar"></div>
              </div>
            </div>
          </div>

          <!-- Right Section: Mic/Action buttons (always shown) -->
          <div class="db-website-prompt__toolbar-right" [ngClass]="{'recording': !!voiceRecording?.isRecording}">
            <!-- Mic/Close button (toggles based on recording state) -->
            <button
              *ngIf="!voiceRecording?.isRecording"
              class="db-website-prompt__btn-circle"
              (click)="voiceRecording.toggleRecording()"
              [disabled]="isProcessing || disableControls"
              [ngClass]="{'processing': isProcessing}">
              <i class="db-icon db-icon-ds-microphone"></i>
            </button>

            <button
              *ngIf="voiceRecording?.isRecording"
              class="db-website-prompt__btn-circle db-website-prompt__btn-circle--danger"
              (click)="voiceRecording.stopRecording()">
              <i class="db-icon db-icon-close"></i>
            </button>

            <!-- Action button (changes based on recording state) -->
            <button
              *ngIf="voiceRecording?.isRecording"
              class="db-website-prompt__btn-circle db-website-prompt__btn-circle--success"
              (click)="voiceRecording.stopRecording()">
              <i class="db-icon db-icon-ds-checkmark"></i>
            </button>

            <button
              *ngIf="!voiceRecording?.isRecording"
              class="db-website-prompt__btn-send"
              [ngClass]="{'disabled': !prompt.trim() || !!disableControls || isProcessing, 'processing': isProcessing}"
              [disabled]="isProcessing || disableControls"
              (click)="onSend()">
              <i *ngIf="!isProcessing" class="db-icon db-icon-ds-suite-enter-arrow"></i>
              <db-loading-circular-spinner
                *ngIf="isProcessing"
                [color]="'monochrome'"
                [size]="'xs_small'"
                [newMode]="true">
              </db-loading-circular-spinner>
            </button>
          </div>
        </div>
    </div>
    <div *ngIf="showCharacterLimitError" class="db-website-prompt__error-message">
      Character limit reached.
    </div>

    @if (!website) {
      <div class="db-website-prompt__footer">
        <div class="db-website-prompt__footer-content">
          <i class="db-icon db-icon-ds-sidebar-hosting"></i>
          <span>{{ 'text_dataCenter' | dbText }}:</span>
          <button
            *ngIf="regions.length"
            class="db-website-prompt__footer-region-btn"
            [dsTooltip]="regionTooltip"
            dsTooltipColor="white"
            [hostClass]="'cover-all'"
            dsTooltipPosition="top"
            dsTooltipAlign="right"
            dsTooltipSize="large"
            dsTooltipMode="hoverStatic"
            [dsTooltipHoveredElement]="'.actions-dropdown'"
            [disabled]="isProcessing || disableControls"
            [ngClass]="{'processing': isProcessing}">
            <span>{{dataCenterLabel}}</span>
            <i class="db-icon db-icon-ds-single-arrow-small"></i>
          </button>
          <span *ngIf="!regions.length">{{dataCenterLabel}}</span>
        </div>
      </div>
    }
  </div>

  <!-- Drag and Drop Overlay -->
  <div class="db-drag-drop-overlay" [class.active]="isDraggingFiles">
    <div class="db-drop-zone">
      <i class="db-icon db-icon-ds-file"></i>
      <div class="db-drop-text mt12">
        <h3>Add images</h3>
        <p class="mt4">Drag and drop images here to add them<br/> to your message</p>
      </div>
    </div>
  </div>
</div>

<!-- Tooltip Templates -->
<ng-template #addTooltip>
  <div class="db-website-prompt__tooltip-content" [class.close]="closeTooltip()">
<!--    <div class="db-website-prompt__tooltip-option" (click)="onImportFromFigma()">
      <div class="db-website-prompt__model-option">
        <div>
          <img src="./assets/images/logos/figma-logo.svg" class="db-website-prompt__tooltip-icon">
          <span>{{ 'text_importFrom' | dbText}} Figma</span>
        </div>
      </div>
    </div>-->
    <div class="db-website-prompt__tooltip-option" *ngIf="!isMobile" (click)="onTakeScreenshot()">
      <div class="db-website-prompt__model-option">
        <div>
          <i class="db-icon db-icon-ds-screenshot"></i>
          <span>{{ 'text_takeAScreenshot' | dbText}}</span>
        </div>
      </div>
    </div>
    <div class="db-website-prompt__tooltip-option" (click)="onAttachMedia()">
      <div class="db-website-prompt__model-option">
        <div>
          <i class="db-icon db-icon-ds-image-upload"></i>
            <span>{{ 'text_attachMedia' | dbText}}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addTooltipDisabled>
  <div class="db-website-prompt__tooltip-content">
    <span>{{'text_fileAttachmentsArentSupportedInTheAiClassicBuilder' | dbText}}</span>
  </div>
</ng-template>

<ng-template #modelTooltip>
  <div class="db-website-prompt__tooltip-content db-website-prompt__tooltip-content--model">
    <div class="db-website-prompt__tooltip-option" (click)="selectModel('wvc')">
      <div class="db-website-prompt__model-option" [ngClass]="{'selected': builderType === 'wvc'}">
        <div>
          <div class="db-website-prompt__model-option-icon">
            <i class="db-icon db-icon-ds-ai"></i>
          </div>
          <div>
            <span class="db-website-prompt__model-name">AI Vibe Builder</span>
            <span class="db-website-prompt__model-desc">React + WordPress</span>
          </div>
        </div>
        <i *ngIf="builderType === 'wvc'" class="db-icon db-icon-ds-checkmark"></i>
      </div>
    </div>
    <div class="db-website-prompt__tooltip-option mt1" (click)="selectModel('section_based')">
      <div class="db-website-prompt__model-option" [ngClass]="{'selected': builderType === 'section_based'}">
        <div>
          <div class="db-website-prompt__model-option-icon">
            <i class="db-icon db-icon-ds-sidebar-builder"></i>
          </div>
          <div>
            <span class="db-website-prompt__model-name">AI Classic Builder</span>
            <span class="db-website-prompt__model-desc">{{ 'text_proFeaturesOnElementor' | dbText }}</span>
          </div>
        </div>
        <i *ngIf="builderType === 'section_based'" class="db-icon db-icon-ds-checkmark"></i>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #regionTooltip>
  <div class="db-website-prompt__tooltip-content db-website-prompt__tooltip-content--region">
    <div
      *ngFor="let region of regions; let i = index"
      class="db-website-prompt__tooltip-option"
      [ngClass]="{'mt1': i > 0}"
      (click)="onRegionChange(region.value)">
      <div class="db-website-prompt__region-option" [ngClass]="{'selected': selectedRegion === region.value}">
        <div>
          <div>
            <span class="db-website-prompt__region-name">{{region.label}}</span>
          </div>
        </div>
        <i *ngIf="selectedRegion === region.value" class="db-icon db-icon-ds-checkmark"></i>
      </div>
    </div>
  </div>
</ng-template>
